import BaseService from "@/shared/base.service";

import { useAlertStore } from "@/stores/alert.store";

import type { SignInResponse } from "@/types/response/signIn";

export class AuthService {
  static async SignIn(
    login: string,
    password: string
  ): Promise<SignInResponse | null> {
    try {
      const response = await BaseService.post<SignInResponse>("login", {
        login: login,
        password: password,
      });

      return response ?? null;
    } catch (error) {
      console.error("Error in SignIn:", error);
      return null;
    }
  }  
  
  static async VerifyMfa(
    mfa_code: string,
    mfa_session_token: string,
    trust_device: boolean
  ): Promise<SignInResponse | null> {
    try {
      const response = await BaseService.post<SignInResponse>("mfa/verify", {
        mfa_code: mfa_code,
        mfa_session_token: mfa_session_token,
        trust_device: trust_device
      });

      return response ?? null;
    } catch (error) {
      console.error("Error in SignIn:", error);
      return null;
    }
  }

  static async SignUp(payload: object): Promise<object | null> {
    try {
      const response = await BaseService.post<object>("first_time_user", {
        ...payload,
      });

      if (response) {
        useAlertStore().show("success", "Conta criada com sucesso.");
      }
      return response ?? null;
    } catch (error) {
      console.error("Error in SignUp:", error);
      return null;
    }
  }

  static async ForgotPassword(payload: object): Promise<object | null> {
    try {
      const response = await BaseService.post<object>("forgot_password", {
        ...payload,
      });

      if (response) {
        useAlertStore().show("success", "Email de recuperação enviado.");
      }
      return response ?? null;
    } catch (error) {
      console.error("Error in ForgotPassword:", error);
      return null;
    }
  }

  static async PasswordReset(payload: object, token?: string): Promise<object | null> {
    try {
      const config = token ? {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      } : undefined;

      const response = await BaseService.post<object>("password_reset", {
        ...payload,
      }, config);

      if (response) {
        useAlertStore().show("success", "Senha alterada com sucesso.");
      }
      return response ?? null;
    } catch (error) {
      console.error("Error in PasswordReset:", error);
      return null;
    }
  }

  static async RefreshToken(refreshToken: string): Promise<SignInResponse | null> {
    try {
      // DRF-style: POST com refresh_token no body
      const response = await BaseService.post<SignInResponse>("refresh_token", {
        refresh_token: refreshToken
      });
      return response ?? null;
    } catch (error) {
      console.error("Error in RefreshToken:", error);
      return null;
    }
  }

  static async Logout() {
    try {
      const response = await BaseService.get("logout");
      return response;
    } catch (error) {
      console.error("Error in Logout:", error);
      return false;
    }
  }



  static async HandleGoogleAuth(token: string): Promise<SignInResponse | null> {
    try {

      const payload = {
        token
      }
      const response = await BaseService.post<SignInResponse>("google/auth", payload);

      return response ?? null;
    } catch (error) {
      console.error("Error in ForgotPassword:", error);
      return null;
    }
  }
}
